import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';

import AppBar from 'layout/AppBar';
import Sidebar from 'layout/Sidebar';
import { ContextMenu } from 'components/Widget/components/menus/DashboardContextMenu';

const useStyles = makeStyles({
  calcMinHeight: {
    minHeight: props => (props.isCanned ? 'calc(100vh-113px)' : 'calc(100vh-64px)'),
    marginLeft: '70px',
    marginTop: props => (props.isCanned ? '105px' : '70px')
  },
  headerStyle: {
    top: 0,
    left: 'auto',
    right: 0,
    position: 'sticky',
    zIndex: 1100
  }
});

const Page = ({
  children,
  isCanned,
  title,
  tabs,
  dashboardData,
  dashboardId,
  dispatchCannedDashboardList,
  isDefaultTemplate,
  isLoading,
  isUserDashboard,
  setIsEditMode,
  isEditMode,
  setWhichPopup
}) => {
  const classes = useStyles({ isCanned });
  return (
    <>
      <header className={classes.headerStyle}>
        <AppBar
          isCanned={isCanned}
          title={title}
          tabs={tabs}
          dashboardData={dashboardData}
          dashboardId={dashboardId}
          isLoading={isLoading}
          isUserDashboard={isUserDashboard}
          setIsEditMode={setIsEditMode}
          isEditMode={isEditMode}
          setWhichPopup={setWhichPopup}
        />
        <Sidebar />
      </header>

      <main className={classes.calcMinHeight}>{children}</main>
      <ContextMenu
        isDefaultTemplate={isDefaultTemplate}
        dispatchCannedDashboardList={dispatchCannedDashboardList}
        dashboardsCount={tabs && tabs.length > 0 && tabs.length}
      />
    </>
  );
};

Page.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  dispatchCannedDashboardList: PropTypes.func,
  dashboardData: PropTypes.shape({
    masterObjectId: PropTypes.number,
    masterObjectName: PropTypes.string,
    masterObjectType: PropTypes.string
  }),
  dashboardId: PropTypes.string,
  isCanned: PropTypes.bool,
  title: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      isDefaultScreen: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      ordinal: PropTypes.number.isRequired,
      isExternal: PropTypes.bool
    })
  ),
  isDefaultTemplate: PropTypes.bool,
  isUserDashboard: PropTypes.bool
};

Page.defaultProps = {
  isCanned: false,
  tabs: [],
  title: null,
  dashboardData: null,
  dashboardId: null,
  dispatchCannedDashboardList: null,
  isDefaultTemplate: false,
  isLoading: false,
  isUserDashboard: false
};

export default Page;
